export default "__VITE_ASSET__CCtj3PVZ__"